import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { connect } from "react-redux";
import styled from "styled-components";
import Clipboard from "react-clipboard.js";

import { Button } from "components/Form";
import iFrameScript from "helpers/iFrameScript";

class AgencyCode extends React.Component {
  state = {
    isOpen: false
  };

  toggle = () => {
    this.setState(({ isOpen }) => ({
      isOpen: !isOpen
    }));
  };

  render() {
    const { agencyUID } = this.props;
    const { isOpen } = this.state;

    return (
      <AgencyStyled>
        <Button color="primary" onClick={this.toggle}>
          Kod dla agencji
        </Button>
        <Modal isOpen={isOpen} toggle={this.toggle}>
          <ModalHeaderStyled>
            <CloseButtonStyled onClick={this.toggle}>x</CloseButtonStyled>
          </ModalHeaderStyled>
          <ModalBodyStyled>
            <p>
              Naciśnij przycisk 'Kopiuj skrypt' poniżej, by skopiowac skrypt, po
              czym wklej go w tagu <code>&lt;head&gt;</code> na swojej stronie.
            </p>
            <ClipboardStyled
              data-clipboard-text={iFrameScript(agencyUID)}
              className="btn btn-xl btn-primary my2"
            >
              Kopiuj skrypt
            </ClipboardStyled>
            <p>
              By dodać widok z ofertami własnej agencji, wklej
              <code className="d-block">
                &lt;div id=&quot;osifw&quot;&gt;&lt;/div&gt;
              </code>
              w htmlu tam gdzie chcesz żeby byly pokazywane.
            </p>
          </ModalBodyStyled>
        </Modal>
      </AgencyStyled>
    );
  }
}

const AgencyStyled = styled.div`
  margin: 0 1rem;
`;
const ModalHeaderStyled = styled(ModalHeader)`
  padding-top: 0;
  padding-bottom: 0;
  border-bottom: none;
  display: flex;
  justify-content: flex-end;
`;
const ModalBodyStyled = styled(ModalBody)`
  word-break: break-word;
  padding: 1rem;
`;
const ClipboardStyled = styled(Clipboard)`
  margin-bottom: 2rem;
`;
const CloseButtonStyled = styled.button`
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: none;
  font-weight: 700;
`;

const mapStateToProps = state => ({
  agencyUID: state.auth.viewer && state.auth.viewer.agencyUID
});

export default connect(mapStateToProps, {})(AgencyCode);



// WEBPACK FOOTER //
// ./src/components/AgencyCode.js